module.exports = __webpack_public_path__ + "img/T6-A-rc_5.141cab47.png";